<template>
  <b-row class="purchase-header justify-content-center">
    <b-col cols="12" lg="7" class="d-flex align-items-center justify-content-center my-2">
      <Steps :status="status" />
    </b-col>
    <b-col v-if="openPlan" class="my-2">
      <div class="d-flex flex-column">
        <div class="title">{{ openPlan.name }}</div>
        <div class="subtitle">{{ openPlan.description }}</div>
        <div class="d-flex align-items-baseline justify-content-between">
          <div class="frequency">{{ openPlan.chargeFrecuency }}</div>
          <div class="price ml-4">
            <span class="currency">$</span><span class="amount">{{ openPlan.originalCost }}</span>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import Steps from '@/components/PurchaseFlow/Header/Steps';
export default {
  components: {
    Steps
  },
  props: {
    status: {
      type: String,
      required: false,
      default: 'plans'
    }
  },
  computed: {
    ...mapState('plans', ['openPlan'])
  }
};
</script>

<style lang="scss" scoped>
.purchase-header {
  background-color: #4194ff;
  border-radius: 5px;
  color: white;
  padding: 15px 10px;
  @include lg {
    padding: 30px 15px;
  }
  .title {
    font-weight: 500;
    font-size: 25px;
  }
  .price {
    font-size: 40px;
  }
  .amount {
    font-weight: 500;
  }
  .currency {
    font-size: 20px;
  }
  .frequency {
    text-transform: lowercase;
  }
}
</style>
